import axios from "axios";
import { PillarTree } from "./BasicSimpleTreeView";
import { useContext, useEffect, useState } from "react";
import { VersionContext } from "../../context/VersionContext";
import { PillarType } from "../../types/Roadmap";
import { FlexGrow } from "../../components/FlexBox";
import { PillarDetail } from "./PillarDetail";
import SnackBar from "../../components/SnackBar";
import ConfirmModal from "../../components/ConfirmModal";
import { useNavigate } from "react-router-dom";

export const ModifyPillars1 = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { version } = useContext(VersionContext);
  const [pillars, setPillars] = useState<PillarType>([]);
  const [createMode, setCreateMode] = useState<string>("Pillar");
  const [currentId, setCurrentId] = useState<any>({});
  const [editMode, setEditMode] = useState<string>("");
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [toDelete, setToDelete] = useState({ element: "", id: "" });
  const [confirmMessage, setConfirmMessage] = useState("");
  const [expanded, setExpanded] = useState<string[]>([]);
  const [showCreatePillar, setShowCreatePillar] = useState(false);
  const [showCreateSubdomain, setShowCreateSubdomain] = useState(false);
  const [showCreateKnowledgeArea, setShowCreateKnowledgeArea] = useState(false);
  const [showCreateKnowledgeTopic, setShowCreateKnowledgeTopic] =
    useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (version.version_number === 0) {
      navigate("/curriculum/version");
    }
    fetchPillars();
  }, []);

  const fetchPillars = () => {
    setLoading(true);
    axios
      .get(`/pillar?curriculum_version=${version.version_number}`)
      .then((res) => {
        if (res.data.pillars) {
          setPillars(res.data.pillars);
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const handleDelete = (element: string, id: string) => {
    setIsConfirmOpen(true);
    switch (element) {
      case "pillar":
        setToDelete({ element: "pillar", id: id });
        break;
      case "subdomain":
        setToDelete({ element: "subdomain", id: id });
        break;
      case "knowledgeArea":
        setToDelete({ element: "knowledgeArea", id: id });
        break;
      case "knowledgeTopic":
        setToDelete({ element: "knowledgeTopic", id: id });
        break;
    }
  };

  const onDelete = (element: string, id: string) => {
    switch (element) {
      case "pillar":
        deletePillar(id);
        break;
      case "subdomain":
        deleteSubdomain(id);
        break;
      case "knowledgeArea":
        deleteKnowledgeArea(id);
        break;
      case "knowledgeTopic":
        deleteKnowledgeTopic(id);
        break;
    }
  };
  const deletePillar = (id: string) => {
    axios
      .delete(
        `/pillar/delete?pillar_id=${id}&curriculum_version=${version.version_number}`
      )
      .then((res: any) => {
        fetchPillars();
        setIsConfirmOpen(false);
        setIsSnackbarOpen(true);
        setMessage("Deleted Pillar Successfully!");
      })
      .catch((err) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const deleteSubdomain = (id: string) => {
    axios
      .delete(
        `/subdomain/delete?subdomain_id=${id}&curriculum_version=${version.version_number}`
      )
      .then((res: any) => {
        fetchPillars();
        setIsConfirmOpen(false);
        setIsSnackbarOpen(true);
        setMessage("Deleted Subdomain Successfully!");
        setShowCreateSubdomain(false);
        setShowCreatePillar(true);
      })
      .catch((err) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };
  const deleteKnowledgeArea = (id: string) => {
    axios
      .delete(
        `/knowledgearea/delete?area_id=${id}&curriculum_version=${version.version_number}`
      )
      .then((res: any) => {
        fetchPillars();
        setIsConfirmOpen(false);
        setIsSnackbarOpen(true);
        setMessage("Deleted Knowledge Area Successfully!");
        setShowCreateKnowledgeArea(false);
        setShowCreateSubdomain(true);
      })
      .catch((err) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };

  const deleteKnowledgeTopic = (id: string) => {
    axios
      .delete(
        `/knowledgetopic/delete?topic_id=${id}&curriculum_version=${
          version.version_number
        }&override_usage=${confirmMessage ? true : false}`
      )
      .then((res: any) => {
        if (!res.data.result.deleted) {
          setConfirmMessage(res.data.result.message);
        } else {
          setIsConfirmOpen(false);
          fetchPillars();
          setConfirmMessage("");
          setIsConfirmOpen(false);
          setIsConfirmOpen(false);
          setIsSnackbarOpen(true);
          setMessage("Deleted Knowledge Topic Successfully!");
          setShowCreateKnowledgeTopic(false);
          setShowCreateKnowledgeArea(true);
        }
      })
      .catch((err) => {
        setIsErrorOpen(true);
        setMessage(err.response.data.error);
      });
  };
  return (
    <>
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <ConfirmModal
        isOpen={isConfirmOpen}
        setOpen={() => setIsConfirmOpen(false)}
        confirmFunction={() => onDelete(toDelete.element, toDelete?.id)}
        title={`Delete ${toDelete.element}`}
        description={
          confirmMessage ||
          `Are you sure do you want to delete the ${toDelete.element} ?`
        }
      />
      <FlexGrow
        style={{
          overflow: "auto",
          display: "flex",
          // maxHeight: "calc(100vh - 90px)",
          minHeight: "calc(100vh - 90px)",
          color: "black",
          background: "white",
        }}
      >
        <PillarTree
          setIsSnackbarOpen={setIsSnackbarOpen}
          expanded={expanded}
          setExpanded={setExpanded}
          handleDelete={handleDelete}
          currentId={currentId}
          setCurrentId={setCurrentId}
          createMode={createMode}
          setCreateMode={setCreateMode}
          setEditMode={setEditMode}
          editMode={editMode}
          pillars={pillars}
        />
        <PillarDetail
          showCreatePillar={showCreatePillar}
          setShowCreatePillar={setShowCreatePillar}
          showCreateSubdomain={showCreateSubdomain}
          setShowCreateSubdomain={setShowCreateSubdomain}
          showCreateKnowledgeArea={showCreateKnowledgeArea}
          setShowCreateKnowledgeArea={setShowCreateKnowledgeArea}
          showCreateKnowledgeTopic={showCreateKnowledgeTopic}
          setShowCreateKnowledgeTopic={setShowCreateKnowledgeTopic}
          setCreateMode={setCreateMode}
          setExpanded={setExpanded}
          expanded={expanded}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setMessage={setMessage}
          message={message}
          setIsErrorOpen={setIsErrorOpen}
          isErrorOpen={isErrorOpen}
          fetchPillars={fetchPillars}
          currentId={currentId}
          createMode={createMode}
          editMode={editMode}
          setEditMode={setEditMode}
        />
      </FlexGrow>
    </>
  );
};
